import { connect } from 'react-redux';

import CardFooter from 'components/dashboard/CardFooter';
import { getLiveParams, getTotalProductionLive } from "selectors/liveParams";
import { getTurbineParamsDefinitionByKey } from "selectors/utils";

const LIVE_PARAMS = 'all' // ['kwh_meter'];
const TURBINE_PARAMAS_DEFINITION = ['wind','power', 'kwh_meter']
// windTurbine can be momentarily undefined during navigation between two
// turbines' detail pages (see components/dashboard/CardHeader.js's
// identical guard, added after this exact crash pattern - "Cannot read
// properties of undefined" - took down the whole page with no error
// boundary to catch it). mapStateToProps runs on every store update, so
// an unguarded ownProps.windTurbine.id here throws just as readily.
const mapStateToProps = (state, ownProps) => {
  const windTurbineId = ownProps.windTurbine && ownProps.windTurbine.id;
  return {
    liveProps: getLiveParams(state, windTurbineId, LIVE_PARAMS),
    productions: getTotalProductionLive(state, windTurbineId),
    turbineParams: getTurbineParamsDefinitionByKey(state, windTurbineId, TURBINE_PARAMAS_DEFINITION),
  };
};

export default connect(mapStateToProps)(CardFooter);
